<template>
  <layout-main-inner title="积分任务">
    <layout-card-wrap>
      <el-table
        v-loading="loading"
        border
        :data="list">
        <el-table-column
          label="规则名称"
          :resizable="false">
          <template slot-scope="scope">
            <span>{{ scope.row.ruleName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="规则描述"
          :resizable="false">
          <template slot-scope="scope">
            <span>{{ scope.row.ruleDesc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否启用"
          :resizable="false"
          width="120">
          <template slot-scope="{row}">
            <el-switch
              :value="row.isopen"
              :active-value="1"
              :inactive-value="0"
              @change="updateState(row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          :resizable="false"
          width="80">
          <template slot-scope="scope">
            <el-button
              type="warning"
              @click="updataIntegral(scope.row,scope.$index)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </layout-card-wrap>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="280px"
      @closed="handleClosed">
      <el-form
        ref="form"
        label-width="100px"
        :model="form"
        :rules="rules">
        <template v-if="form.ruleType === 11">
          <el-form-item
            label="积分："
            prop="points">
            <el-input-number
              v-model="form.points"
              :min="0"></el-input-number>
          </el-form-item>
        </template>
        <template v-if="form.ruleType === 13">
          <el-form-item
            label="积分："
            prop="points">
            <el-input-number
              v-model="form.points"
              :min="0"></el-input-number>
          </el-form-item>
          <el-form-item
            :key="1"
            label="日积分上限："
            prop="dailyPointsLimit">
            <el-input-number
              v-model="form.dailyPointsLimit"
              :min="form.points"
              :step="form.points"></el-input-number>
          </el-form-item>
        </template>
        <template v-if="form.ruleType === 15">
          <el-form-item
            label="兑换比例："
            prop="exchangeRatio">
            <el-input-number
              v-model="form.exchangeRatio"
              :min="0"></el-input-number>
          </el-form-item>
          <el-form-item
            :key="1"
            label="日兑换上限："
            prop="dailyPointsLimit">
            <el-input-number
              v-model="form.dailyPointsLimit"
              :min="0"></el-input-number>
          </el-form-item>
        </template>

      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          @click="updateSubmit">确 定</el-button>
        <el-button @click="visible = false">取 消</el-button>
      </div>
    </el-dialog>
    <offline-scan-modal ref="scan" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import OfflineScanModal from '../offline-scan-modal.vue'
export default {
  name: 'IntegralTask',
  components: { OfflineScanModal },
  data() {
    return {
      loading: true,
      visible: false,
      list: [],
      form: {},
      title: '',
      rules: {
        points: [
          { required: true, message: '请输入积分', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  watch: {
    'form.points'(val) {
      if (this.form.ruleType === 13) {
        this.form.dailyPointsLimit = val
      }
    }
  },

  mounted() {
    this.fetchList()
  },
  methods: {
    handleClosed() {
      this.$refs['form'].resetFields()
    },
    updateSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(`integral/updatepointstask`, {
            payload: {
              vendorId: this.form.vendorId,
              pointsRuleId: this.form.pointsRuleId,
              points: this.form.points,
              exchangeRatio: this.form.exchangeRatio,
              dailyPointsLimit: this.form.dailyPointsLimit,
              ruleJson: this.form.ruleType === 15 ? JSON.stringify({ exchangeRatio: this.form.exchangeRatio,
                dailyPointsLimit: this.form.dailyPointsLimit }) : null
            },
            success: () => {
              this.loading = false
              this.visible = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    updataIntegral(row) {
      if (row.ruleType === 9) { // 扫码送积分
        this.$router.push({ path: '/wxapp-point-scan' })
      } else if (row.ruleType === 2) { // 支付送积分
        this.$router.push({ path: '/wxapp-point-pay' })
      } else if (row.ruleType === 14) { // 线下
        this.$refs.scan.fetch(row.vendorId)
      } else {
        this.loading = true
        this.$store.dispatch(`integral/getpointstask`, {
          payload: {
            vendorId: row.vendorId,
            ruleType: row.ruleType
          },
          success: res => {
            this.loading = false
            const ruleJson = row.ruleType === 15 ? JSON.parse(res.data.ruleJson) : res.data.ruleJson
            this.form = {
              ...this.form,
              ...res.data,
              exchangeRatio: row.ruleType === 15 ? ruleJson.exchangeRatio : null
              // dailyPointsLimit: row.ruleType === 15 ? ruleJson.dailyPointsLimit : res.data.dailyPointsLimit
            }
            // this.form.dailyPointsLimit = 10000
            this.$set(this.form, 'dailyPointsLimit', row.ruleType === 15 ? ruleJson.dailyPointsLimit : res.data.dailyPointsLimit)
            this.title = ({ 11: '完善资料送积分', 13: '邀请好友送积分', 15: '步数换积分' })[row.ruleType]
            this.visible = true
          },
          fail: () => {
            this.loading = false
          }
        })
      }
    },
    updateState(row) {
      this.loading = true
      const dispatch = row.isopen === 1 ? 'closerule' : 'openrule'
      this.$store.dispatch(`integral/${dispatch}`, {
        payload: {
          vendorId: row.vendorId,
          ruleId: row.ruleId
        },
        success: () => {
          this.loading = false
          this.fetchList()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('integral/getrulelist', {
        payload: {
          pageSize: 1000,
          pageNum: 1,
          vendorId: this.userInfo.vendorId
        },
        success: res => {
          this.loading = false
          // this.list = res.data.records.filter(i => i.ruleType !== 10)
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
